import React from 'react';

interface DeleteIconProps {
  onClick?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({ onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ff5252"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-trash"
    onClick={(e) => (onClick ? onClick(e) : null)}
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6L17.5 20.5a1 1 0 0 1-1 .5H7.5a1 1 0 0 1-1-.5L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
